import React from 'react'
import styled from 'styled-components'
import { giphyIndigo } from '../../styles/colors'
import CreateNewApp from '../utils/qa-events'

export const Button = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: InterFace;
    font-weight: bold;
    font-size: 15px;
    color: #fff;
    background: ${giphyIndigo};
    height: 36px;
    width: 348px;
    margin: 10px auto;
`

// add in link
const CreateAppButton = () => (
    <Button href="/dashboard/?create=true" onClick={CreateNewApp}>
        Create an App
    </Button>
)

export default CreateAppButton
